import { z } from "zod"

export const schemaPhoneNumber = z
  .string()
  .regex(/^\d{11,14}$/, { message: 'Invalid number' })
  .transform((arg) => {
    return `+${arg}`
  })
